import PropTypes from 'prop-types';

export const SIZES = PropTypes.oneOf(['none', 'gutter', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']);
export const SIZES_WITH_RESPONSIVE_OPTION = PropTypes.oneOfType([
    PropTypes.arrayOf(SIZES),
    SIZES
])
